import React, { createContext, useContext, useState } from "react";
import Notification, {
  NotificationType,
} from "../components/shared/Notification";

const NotificationContext = createContext<{
  setNotification: (n: NotificationType | null) => void;
}>({
  setNotification: () => {},
});

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [notification, setNotification] = useState<NotificationType | null>(
    null,
  );

  return (
    <NotificationContext.Provider value={{ setNotification }}>
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}
      {children}
    </NotificationContext.Provider>
  );
};
